import { render, staticRenderFns } from "./PageIntegrateUs.vue?vue&type=template&id=05032a14&"
import script from "./PageIntegrateUs.vue?vue&type=script&lang=js&"
export * from "./PageIntegrateUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports